import { Route, Routes } from "react-router-dom";

import { Contact } from "./Contact";
import { Cookie } from "./Cookie";
import { Footer } from "../../components/Footer";
import { History } from "./History";
import { Home } from "./Home";
import { NavigationBar } from "../../components/NavigationBar";
import { Privacy } from "./Privacy";
import React from "react";
import { Vineyards } from "./Vineyards";
import { Wine } from "./Wine";
import { Wines } from "./Wines";

export const RouteIt = ()=> {

    return (
      <React.Fragment>
          <NavigationBar />
          <div className="content">
            <Routes>
              <Route path="/" element={<Home />} /> 
              <Route path="/storia" element={<History />} />
              <Route path="/contatti" element={<Contact />} />
              <Route path="/vigneti" element={<Vineyards />} />
              <Route path="/vigneti/:nome" element={<Vineyards />} />
              <Route path="/vini" element={<Wines />} />
              <Route path="/vini/:nome" element={<Wines />} />
              <Route path="/:nome/:anno" element={<Wine />} />
              <Route path="/cookie" element={<Cookie />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </div>
          <Footer />
      </React.Fragment>
    );
  }


